import { render } from "./EventsLongCard.vue?vue&type=template&id=8f81580a"
import script from "./EventsLongCard.vue?vue&type=script&lang=js"
export * from "./EventsLongCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__